/**
 * Addresses in a box — an email's *Cc* and *Bcc* (Aaron, Oct 26: "in cc and
 * bcc, you should be able to add multiple email addresses").
 *
 * One reader of what somebody typed or pasted, for the composer, New email
 * and a record's email alike, and one test of an address — zod's, the same
 * `email()` the server validates with — so a chip the box draws as good is
 * one the server takes.
 */
import { z } from 'zod';
const ONE_ADDRESS = z.string().email().max(320);
/** Whether `value` is one email address, as the server will judge it. */
export const isEmailAddress = (value) => ONE_ADDRESS.safeParse(value.trim()).success;
/** How two addresses are told to be the same: trimmed and lower case. */
export const addressKeyOf = (value) => value.trim().toLowerCase();
/**
 * What was typed or pasted, as the separate things in it, in order and once
 * each (case aside). Commas, semicolons, line breaks and spaces separate;
 * `Dana Okafor <dana@example.com>` — what a copy out of Outlook or Gmail
 * looks like — is the address in its brackets; `mailto:` and stray quotes are
 * dropped. Whatever is left that is not an address is still returned, so the
 * box can show it flagged rather than lose it.
 */
export function splitAddresses(text) {
    const bracketed = text.replace(/(?:"[^"]*"|[^,;<>\n])*<([^<>]*)>/g, ' $1 ');
    const seen = new Set();
    const out = [];
    for (const raw of bracketed.split(/[\s,;]+/)) {
        const piece = raw.replace(/^mailto:/i, '').replace(/^["'(<[]+|["')>\]]+$/g, '').trim();
        if (!piece)
            continue;
        const key = addressKeyOf(piece);
        if (seen.has(key))
            continue;
        seen.add(key);
        out.push(piece);
    }
    return out;
}
//# sourceMappingURL=addresses.js.map